import { APIClient } from '../helpers/api_helper';
const AxiosClient = new APIClient()

const fetchTaggingOptions = () => AxiosClient.get(`/get-tagging-options`);

const addTaggingHistory = payload => AxiosClient.post(`/create-tagging-history`, payload);

export {
    fetchTaggingOptions,
    addTaggingHistory
}